<template>
  <div class="services-list__item-head bonus-section" v-if="bonusAmount">
    <div class="shop-button-container">
      <a :href="finalShopLink" class="shop-button">
        <div class="shop-icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 0 1-8 0"/>
          </svg>
        </div>
        <span class="shop-text">До магазину</span>
      </a>
    </div>

    <div class="services-list__info-item">
      <div class="bonus-cont">
        <div>Кількість бонусів</div>
        <div class="bonus-amount">{{ bonusAmount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BonusSection",

  props: {
    bonusAmount: {
      type: [Number, String],
      required: true
    },
    shopLink: {
      type: String,
      default: "https://club.everest24.com.ua/ua"
    }
  },

  computed: {
    accountNumber() {
      return this.$store.state.accountNumber;
    },

    everokToken() {
      return this.$store.state.everokToken;
    },

    finalShopLink() {
      const token = this.everokToken;
      if (!this.accountNumber || !token) {
        return this.shopLink;
      }
      if (this.accountNumber < 1000000) {
        return `https://club.everest24.com.ua/ua/user/token/${token}`;
      }

      return `https://club-km.everest24.com.ua/ua/user/token/${token}`;
    }
  }
};
</script>

<style scoped>


.services-list__item-head {
  flex-direction: row !important;
  border: none !important;
}
.bonus-section {
  flex-direction: row;
  align-items: center;
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
  border: 2px solid transparent;
  background-clip: padding-box;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 8px;
    padding: 2px;
    background: linear-gradient(135deg, #4d7bff 0%, #7b9dff 100%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0.5;
    transition: opacity 0.3s ease;
  }
  
  &:hover::before {
    opacity: 1;
  }
}

.services-list__info-item i {
  font-size: 0.9rem;
  color: #217bf373;
}

/* Enhanced shop button with premium fancy styling */
.shop-button-container {
  display: flex;
  align-items: center;
}

.shop-button {
  display: flex;
  align-items: center;
  gap: 0;
  text-decoration: none;
  position: relative;
  padding: 4px;
  border-radius: 50px;
  background: linear-gradient(135deg, #4d7bff 0%, #6b8fff 50%, #8ba5ff 100%);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(77, 123, 255, 0.3);
  
  &:hover {
    gap: 10px;
    padding-right: 16px;
    box-shadow: 0 8px 25px rgba(77, 123, 255, 0.4);
  }
  
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50px;
    background: linear-gradient(135deg, #6b8fff 0%, #8ba5ff 50%, #aab9ff 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
  }
  
  &:hover::before {
    opacity: 1;
  }
}

.shop-icon-wrapper {
  position: relative;
  z-index: 1;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.shop-button:hover .shop-icon-wrapper {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(77, 123, 255, 0.2);
}

.shop-icon {
  width: 28px;
  height: 28px;
  color: #4d7bff;
  transition: color 0.3s ease;
}

.shop-button:hover .shop-icon {
  color: #3a5fd9;
}

.shop-text {
  position: relative;
  z-index: 1;
  font-size: 1rem;
  font-weight: 700;
  color: #ffffff;
  white-space: nowrap;
  opacity: 0;
  max-width: 0;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.5px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.shop-button:hover .shop-text {
  opacity: 1;
  max-width: 150px;
}

/* Enhanced bonus amount display with fancy styling */
.bonus-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  
  > div:first-child {
    font-size: 0.875rem;
    color: #6b7280;
    font-weight: 500;
  }
}

.bonus-amount {
  font-size: 1.5rem;
  font-weight: 800;
  background: linear-gradient(135deg, #4d7bff 0%, #7b9dff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 2px 4px rgba(77, 123, 255, 0.3));
}

</style>